import { Link } from 'react-router-dom'
import { aud, tidyName } from '../lib/format.js'
import { isStudioPhoto } from '../data/site.js'
import ProductImage from './ProductImage.jsx'

export default function ProductCard({ product }) {
  const img = (product.images || [])[0]
  const hasRange = product.min_price != null && product.max_price != null && product.min_price !== product.max_price
  const price = product.min_price ?? product.price
  const sale = product.min_sale_price ?? product.sale_price
  return (
    <Link to={`/product/${encodeURIComponent(product.sku)}`} className="product-card">
      <div className={`product-card-media ${isStudioPhoto(product) ? 'media-fit' : ''}`}>
        <ProductImage src={img} category={product.category} alt={product.name} loading="lazy" />
        {product.price != null && product.stock === 0 ? (
          <span className="badge badge-out">Out of stock</span>
        ) : sale != null && <span className="badge badge-sale">Sale</span>}
      </div>
      <div className="product-card-body">
        <span className="product-card-cat">{product.subcategory || product.category}</span>
        <h3>{tidyName(product.name)}</h3>
        {product.price_on_request ? (
          <p className="product-card-price"><strong className="price-enquire">Contact us for a price</strong></p>
        ) : price != null && (
          <p className="product-card-price">
            {hasRange && <span className="from">From </span>}
            {sale != null ? (
              <>
                <s>{aud(price)}</s> <strong className="sale">{aud(sale)}</strong>
              </>
            ) : (
              <strong>{aud(price)}</strong>
            )}
            <span className="ex-gst"> ex GST</span>
          </p>
        )}
      </div>
    </Link>
  )
}
